import { app, HostClientType } from "@microsoft/teams-js";
import { appInsights } from "libs/app-insights";
import { getTeamsContext, initializeTeamsSDK } from "libs/teams/helper";
import { atom, selector } from "recoil";

/**
 * 팀즈 컨텍스트
 */
export const msTeamsContextQuery = selector<app.Context>({
  key: "msTeamsContextQuery",
  get: async () => {
    await initializeTeamsSDK();
    return await getTeamsContext();
  },
});

/**
 * Teams App에서 지원하는 테마 목록입니다.
 * 기본적으로 테마를 변수로 구분하여 불편한 점이 있기 때문에 쉽게 구분하기 위한 문자열 열거형입니다.
 */
export type teamsAppThemeList = "default" | "dark" | "contrast";

/**
 * 팀즈 테마
 */
export const msTeamsThemeState = atom<teamsAppThemeList>({
  key: "msTeamsThemeState",
  default: selector({
    key: "defaultTeamsTheme",
    get: ({ get }) => {
      const msTeamsContext = get(msTeamsContextQuery);
      return (msTeamsContext.app.theme as teamsAppThemeList) ?? "default";
    },
  }),
});

export const isMobileState = selector<boolean>({
  key: "isMobileState",
  get: ({ get }) => {
    const msTeamsContext = get(msTeamsContextQuery);
    const clientType = msTeamsContext.app.host.clientType;

    switch (clientType) {
      case HostClientType.desktop:
      case HostClientType.web:
        return false;
      case HostClientType.android:
      case HostClientType.ios:
      case HostClientType.ipados:
        return true;
      default:
        appInsights.trackException({
          exception: new Error("예상하지 못한 Teams HostClientType 발견"),
          properties: {
            HostClientType: clientType,
          },
        });
        // 모바일 환경 디바이스일 확률이 매우 높고 모바일 디바이스가 앱 내에서 권한 정책이 있으므로, 일단 모바일로 분류합니다.
        return true;
    }
  },
});
